<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.edit_credits">
  <app-popup-header title="{{localService.languageContent.edit_credits.user_credits}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-5">
        <app-label [Text]="localService.languageContent.edit_credits.current_credits"></app-label>
      </div>
      <div class="col-7">
        <span class="en">{{isCurrentCreditNegative ? '-' : ''}}&nbsp;{{currentCreditsValue | number: '1.2-2'}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <app-label [Text]="localService.languageContent.common.action" [IsMandatory]="true"></app-label>
      </div>
      <div class="col-9">
        &nbsp;
        <label style="font-weight:normal;">
          <input type="radio" name="credit_action" (click)="onRadioChecked(1)">
          <span>{{localService.languageContent.edit_credits.add_credit}}</span>
        </label>
        &nbsp; &nbsp;
        <label style="font-weight:normal;">
          <input type="radio" name="credit_action" (click)="onRadioChecked(2)">
          <span>{{localService.languageContent.edit_credits.deduct_credit}}</span>
        </label>
      </div>
    </div>
    <div class="row en" *ngIf="isAddCredit != null">
      <div class="col-4" style="text-align:right;">
        <span *ngIf="!isAddCredit">&nbsp;-&nbsp;</span>
        <input autocomplete="off" type="number" class="number" (keypress)="localService.isNumberOnly($event,numericConfig)" min="0" id="{{elementIds.new_credits}}" style="width:calc(100% - 25px);text-align:right;" [ngClass]="credit != null ? 'en' : localService.selectedLanguageCode" [(ngModel)]="credit" placeholder="*{{localService.languageContent.edit_credits.amount}}" title="*{{localService.languageContent.edit_credits.amount}}" (keydown.enter)="localService.onFocusNextInput(elementIds.new_credits_note,1)" />
      </div>
      <div class="col-3">
        <span>{{isCurrentCreditNegative ? '-' : '+'}}&nbsp;{{currentCreditsValue | number: '1.2-2'}}&nbsp;</span>
      </div>
      <div class="col-5">
        <span>&nbsp;=&nbsp;{{credit == null && isCurrentCreditNegative ? '-' : ''}}{{(credit == null ? currentCreditsValue : ((isAddCredit ? (isCurrentCreditNegative ? (credit - currentCreditsValue) : (currentCreditsValue + credit)) : (isCurrentCreditNegative ? (-currentCreditsValue - credit) : (currentCreditsValue - credit))))) | number: '1.2-2'}}</span>
      </div>
    </div>
    <div class="row" *ngIf="isAddCredit != null">
      <div class="col-12">
        <input autocomplete="off" type="text" id="{{elementIds.new_credits_note}}" [(ngModel)]="notes" placeholder="{{localService.languageContent.edit_credits.credits_note}}" title="{{localService.languageContent.edit_credits.credits_note}}" (keydown.enter)="localService.onFocusNextInput(elementIds.btn_save_credit,5)" />
      </div>
    </div>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" id="{{elementIds.btn_save_credit}}" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
